import { graphql } from 'react-apollo'
import { withRouter } from 'react-router'

import { datadogRum } from '@datadog/browser-rum'
import { pathOr } from 'ramda'
import { compose, withHandlers, withProps, withState } from 'recompose'

import { withTrackClickedHandler } from 'components/trackers'
import { WVProps } from 'pages/spend/direct-deposit/online/OnlineComponents'
import { BackButtonTapped } from 'pages/spend/direct-deposit/online/segment'
import withWebView from 'pages/spend/direct-deposit/withWebView'
import { USDFormatter } from 'utils/number/currency'

import startSwitchMutation from '../startSwitch.mutation.gql'

const enhance = compose<WVProps, {}>(
  withTrackClickedHandler((props) =>
    BackButtonTapped(pathOr('', ['location', 'state', 'employerName'], props)),
  ),
  withWebView,
  withRouter,
  graphql(startSwitchMutation, {
    name: 'startSwitch',
  }),
  withState('processing', 'setProcessing', false),
  withProps<Partial<WVProps>, WVProps>((props) => {
    if (!props.data.loading) {
      return {
        balance: USDFormatter.format(
          pathOr(0, ['spendAccounts', 0, 'balance', 'value'], props.data),
        ),
        routingNumber: pathOr(
          0,
          ['spendAccounts', 0, 'routingNumber'],
          props.data,
        ).toString(),
        accountNumber: pathOr(
          0,
          ['spendAccounts', 0, 'number'],
          props.data,
        ).toString(),
        bankAccountId: pathOr('', ['spendAccounts', 0, 'id'], props.data),
        employerName: pathOr('', ['location', 'state', 'employerName'], props),
        employerId: pathOr('', ['location', 'state', 'employerId'], props),
        ctaUrl: pathOr('', ['location', 'state', 'ctaUrl'], props),
        clickSwitchTargetId: pathOr(
          '',
          ['location', 'state', 'clickSwitchTargetId'],
          props,
        ),
      }
    } else {
      return {
        employerName: pathOr('', ['location', 'state', 'employerName'], props),
        employerId: pathOr('', ['location', 'state', 'employerId'], props),
        ctaUrl: pathOr('', ['location', 'state', 'ctaUrl'], props),
        clickSwitchTargetId: pathOr(
          '',
          ['location', 'state', 'clickSwitchTargetId'],
          props,
        ),
      }
    }
  }),
  withHandlers({
    handleEdit:
      ({ history }) =>
      () => {
        history.goBack()
      },
    handleGoToEmployer:
      ({
        employerId,
        setProcessing,
        startSwitch,
        bankAccountId,
        mobileSessionId,
      }) =>
      () => {
        setProcessing(true)
        startSwitch({
          variables: {
            employerId,
            bankAccountId,
            sessionId: mobileSessionId,
          },
        }).then(
          () => {
            setProcessing(false)
          },
          (err) => {
            datadogRum.addError(err)
          },
        )
      },
  }),
)

export default enhance
